<template>
  <div>
    <a-col :span="8">
      <a-form-model-item :colon="false" label="盘点仓库"
        :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="deliverWarehouseCode">
        <slot></slot>
      </a-form-model-item>
    </a-col>
    <a-col :span="8">
      <a-form-model-item :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" label="要求完成时间" prop="needFinishTime">
        <a-date-picker 
        v-model="form.needFinishTime" 
        :disabled-date="disabledDate"
        placeholder="选择要求完成时间" 
        show-time
        format="YYYY-MM-DD HH:mm"
        />
      </a-form-model-item>
    </a-col>
  </div>
</template>

<script>
  export default {
    name:'BaseForm',
    components:{
    },
    props:{
      form:{
        type:Object,
        default:()=>{}
      },
      disabledDate:{
        type:Function,
        default:()=>{},
      }
    },
    data(){
      return {

      }
    },
    methods:{
      
    }
  }
</script>

<style lang="scss" scoped>

</style>